import Vue from 'vue'
import VueRouter from 'vue-router'
import { createPinia, PiniaVuePlugin } from 'pinia'
import Layout from './components/shared/layout'
import axios from 'axios'

window.$ = window.jQuery = require('jquery')

axios.interceptors.response.use(function (response) {
    return response
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error

    if (error.response.status === 401) {
        window.location.href = '/'
    }

    return Promise.reject(error)
})

const routes = [
    // Logik för dynamisk booking matchning sker nere i created()
    {
        path: '/booking/clinic',
        name: 'booking',
        component: require('./components/shared/booking.vue').default,
        meta: { requiresAuth: true, pageTitle: 'Boka massage - Hälsoresurs' },
        children: [
            {
                path: 'clinics/:clinic',
                name: 'modal-clinic',
                component: require('./components/shared/modal-clinic').default,
                meta: { closeTo: 'booking', pageTitle: 'Massör - Hälsoresurs' }
            },
            {
                path: 'addresses/:address',
                name: 'modal-address',
                component: require('./components/shared/modal-address').default,
                meta: { closeTo: 'booking', pageTitle: 'Massör - Hälsoresurs' }
            }
        ]
    },
    {
        path: '/booking/workplace',
        name: 'booking-workplace',
        component: require('./components/company/booking-workplace').default,
        meta: { requiresAuth: true, pageTitle: 'Boka på din arbetsplats - Hälsoresurs' }
    },
    {
        path: '/treatments',
        name: 'treatments',
        component: require('./components/company/treatments').default,
        meta: { requiresAuth: true, pageTitle: 'Behandlingar - Hälsoresurs' },
        children: [
            {
                path: 'clinics/:clinic',
                name: 'treatments-clinic',
                component: require('./components/shared/modal-clinic').default,
                meta: { closeTo: 'treatments', pageTitle: 'Massör - Hälsoresurs' }
            }
        ]
    },
    {
        path: '/faq',
        component: require('./components/shared/faq').default,
        meta: { requiresAuth: true, pageTitle: 'FAQ - Hälsoresurs' }
    },
    {
        path: '/account',
        component: require('./components/company/account').default,
        meta: { requiresAuth: true, pageTitle: 'Konto - Hälsoresurs' }
    },

    {
        path: '/login',
        component: require('./components/company/auth/login').default,
        meta: { requiresAuth: false, guestOnly: true, pageTitle: 'Logga in - Hälsoresurs' }
    },
    {
        path: '/password/forgot',
        component: require('./components/company/auth/forgot-password').default,
        meta: { requiresAuth: false, hideAddToHomeScreen: true, pageTitle: 'Begär ett nytt lösenord - Hälsoresurs' }
    },
    {
        path: '/password/reset',
        component: require('./components/company/auth/restore-password').default,
        meta: {
            requiresAuth: false,
            mode: 'reset',
            hideAddToHomeScreen: true,
            pageTitle: 'Återställ lösenord - Hälsoresurs'
        }
    },
    {
        path: '/activate',
        component: require('./components/company/auth/restore-password').default,
        meta: {
            requiresAuth: false,
            mode: 'activate',
            hideAddToHomeScreen: true,
            pageTitle: 'Aktivera ditt konto - Hälsoresurs'
        }
    },
    {
        path: '/:token/:slug',
        component: require('./components/company/auth/register').default,
        meta: { requiresAuth: false, hideAddToHomeScreen: true, pageTitle: 'Skapa konto - Hälsoresurs' }
    }
]

const router = new VueRouter({
    routes,
    mode: 'history'
})

router.beforeEach((to, from, next) => {
    window.document.title = to.meta.pageTitle

    if (from.name == 'modal-clinic' || from.name == 'modal-address' || from.name == 'treatments-clinic') {
        jQuery('html').removeClass('modal-open')
    }

    if (to.name == 'modal-clinic' || to.name == 'modal-address' || to.name == 'treatments-clinic') {
        jQuery('html').addClass('modal-open')
    }

    if (to.matched.some(record => record.meta.guestOnly) && window.auth) {
        next({ path: '/', replace: true })
        return
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!window.auth) {
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            })
        } else {
            next()
        }
    } else {
        next() // make sure to always call next()!
    }
})

const pinia = createPinia()

Vue.use(PiniaVuePlugin)
Vue.use(VueRouter)

Vue.mixin({
    data () {
        return {
            app_version: window.app_version,
            auth: window.auth,
            booking_internal: window.booking_internal,
            booking_external: window.booking_external,
            subscription_status: window.subscription_status
        }
    },
    methods: {
        matomoTrackEvent (action, name, value) {

        }
    }
})

const app = new Vue({
    router,
    pinia,
    components: {
        Layout
    },
    created () {
        if (this.auth) {
            axios.defaults.baseURL = '/data'
        }

        if (!this.auth) {
            this.$router.addRoute({
                path: '',
                name: 'login-index',
                component: require('./components/company/auth/login').default,
                meta: { requiresAuth: false, pageTitle: 'Logga in - Hälsoresurs' }
            })
            return
        }

        if (this.booking_internal && !this.booking_external) {
            this.$router.addRoute({
                path: '',
                name: 'booking',
                component: require('./components/shared/booking').default,
                meta: { requiresAuth: true, pageTitle: 'Boka massage - Hälsoresurs' }
            })
            return
        }
        if (!this.booking_internal && this.booking_external) {
            this.$router.addRoute({
                path: '',
                name: 'booking',
                component: require('./components/company/booking-workplace').default,
                meta: { requiresAuth: true, pageTitle: 'Boka massage - Hälsoresurs' }
            })
            return
        }
        this.$router.addRoute({
            path: '',
            name: 'booking',
            component: require('./components/company/booking').default,
            meta: { requiresAuth: true, pageTitle: 'Boka massage - Hälsoresurs' }
        })
    }
}).$mount('#app')

// Browser
if (!window.matchMedia('(display-mode: standalone)').matches && (!('standalone' in window.navigator) || (('standalone' in window.navigator) && !window.navigator.standalone))) {
    var element = document.getElementById('body')
    element.classList.add('browser')
}

// Standalone PWA
if (window.matchMedia('(display-mode: standalone)').matches || (('standalone' in window.navigator) && window.navigator.standalone)) {
    var element = document.getElementById('body')
    element.classList.add('standalone')
}
